import React, { ReactNode } from "react";
import { useBottomControlsSectionCollapse } from "@rentablo/components";
import { ChartTypeTabs } from "../../SecuritiesChart/ChartTypeTabs";
import { useChartControls } from "../ChartControlsContext";

interface Props {
  // Shown at the end of the tab line, e.g. the comparison on phones.
  action?: ReactNode;
}

export const ChartTypeControl = ({ action }: Props) => {
  const { controls, chartType, setChartType } = useChartControls();
  const collapseSection = useBottomControlsSectionCollapse();

  if (!controls.showChartType) {
    return null;
  }

  return (
    <ChartTypeTabs
      chartType={chartType}
      action={action}
      onChartTypeChange={(value) => {
        setChartType(value);
        collapseSection();
      }}
    />
  );
};
